<template>
    <div ref="form">
        <div class="vx-card__title mb-4">
            <h4 class="mb-4">Login</h4>
            <p>Welcome back, please login to your account.</p>
        </div>

        <div>
            <vs-input
                name="email"
                icon-no-border
                icon="icon-user"
                icon-pack="feather"
                placeholder="Email"
                v-model="localEmail"
                v-validate="'required|email'"
                class="w-full inline-validation"
                val-icon-success="icon-check"
                val-icon-danger="icon-x"
                val-icon-pack="feather"
                @input="resetAuth"
                @keyup.enter="submit"
                :success="registered && !!email && !errors.has('email')"
                :danger="!registered || errors.has('email')"
                :danger-text="!registered ? 'Email not registered' : errors.first('email')"
            />

            <vs-input
                type="password"
                name="password"
                icon-no-border
                icon="icon-lock"
                icon-pack="feather"
                placeholder="Password"
                v-model="password"
                v-validate="'required'"
                class="w-full inline-validation mt-2"
                val-icon-danger="icon-x"
                val-icon-pack="feather"
                @input="resetAuth"
                @keyup.enter="submit"
                :danger="failedAuth || errors.has('password')"
                :danger-text="failedAuth ? 'Invalid credentials' : errors.first('password')"
            />

            <div class="flex flex-wrap justify-between mt-2">
                <vs-checkbox tabindex="-1" v-model="remember" class="mb-3"> Remember </vs-checkbox>
                <a tabindex="-1" v-if="enableForgot" href="#" @click="$emit('forgot')"
                    >Forgot Password?</a
                >
            </div>
            <vx-button
                class="mt-4"
                tabindex="-1"
                v-if="enableRegister"
                type="border"
                @click="$emit('register')"
                >Register</vx-button
            >
            <vx-button :disabled="failedAuth || !validated" class="float-right mt-4" @click="submit"
                >Login</vx-button
            >
        </div>
    </div>
</template>

<script>
export default {
    name: 'sign-in',
    props: {
        enableForgot: {
            type: Boolean,
            default: true
        },
        email: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            password: '',
            remember: false,
            failedAuth: false,
            registered: true
        }
    },
    computed: {
        localEmail: {
            get() {
                return this.email
            },
            set(val) {
                this.$emit('update:email', val)
            }
        },
        enableRegister() {
            return this.$store.state.config.VUE_APP_ALLOW_USER_REGISTRATION === 'true'
        },
        validated() {
            return !this.errors.any() && this.email !== '' && this.password !== ''
        }
    },
    methods: {
        resetAuth() {
            this.failedAuth = false
            this.registered = true
        },
        async submit() {
            if (await this.$validator.validate()) {
                try {
                    this.startLoad(this.$refs.form)
                    var minDelay = this.delayFor(1000)
                    const payload = {
                        remember: this.remember,
                        username: this.localEmail,
                        password: this.password
                    }
                    await this.$store.dispatch('auth/login', payload)
                    await minDelay
                } catch (error) {
                    //Use the notifyServerError for handling all kind of response.status/code

                    if (error.response.status == 401) {
                        this.failedAuth = true
                    } else if (error.response.status == 404) {
                        this.registered = false
                    } else {
                        console.error(error)
                    }
                } finally {
                    this.endLoad(this.$refs.form)
                }
            }
        }
    }
}
</script>
